import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const K = {
  ink: "#004058",
  mid: "#4A6B7C",
  lt: "#94A3B8",
  sur: "#FFFFFF",
  bg: "#F8FAFC",
  brd: "#E2E8F0",
  alt: "#F1F5F9",
  red: "#EF4444",
  grn: "#10B981",
  mp: "#009EE3",
  r: { s: 6, m: 10, p: 14, l: 20, xl: 24, xxl: 32 },
  sh: { 
    s: "0 1px 4px rgba(0,0,0,.05)", 
    m: "0 4px 16px rgba(0,0,0,.08)", 
    l: "0 12px 40px rgba(0,0,0,.11)", 
    xl: "0 24px 72px rgba(0,0,0,.16)" 
  }
};

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: K.bg, fontFamily: "'Open Sans', sans-serif" }}>
      
      {/* Header Fixo */}
      <nav style={{
        background: "rgba(255,255,255,0.9)", backdropFilter: "blur(10px)", 
        borderBottom: `1px solid rgba(0,0,0,0.05)`, padding: "0 24px", height: 70, 
        display: "flex", alignItems: "center", justifyContent: "space-between", 
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 50
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <span 
            style={{ fontFamily: "'Poppins', sans-serif", fontSize: 24, fontWeight: 800, color: K.ink, cursor: "pointer" }} 
            onClick={() => navigate("/")}
          >
            Eventos<span style={{ color: "#009EE3" }}>&</span>Encontros
          </span>
        </div>
        <button 
          onClick={() => navigate("/")}
          style={{
            background: K.alt, color: K.ink, border: "none", padding: "8px 16px", 
            borderRadius: K.r.m, fontWeight: 700, cursor: "pointer", fontSize: 13
          }}
        >
          Voltar para Início
        </button>
      </nav>

      {/* Hero Section */}
      <header style={{
        background: `linear-gradient(135deg, ${K.ink} 0%, #001f2b 100%)`,
        padding: "140px 24px 80px",
        color: "#fff",
        textAlign: "center"
      }}>
        <div className="fu" style={{ maxWidth: 700, margin: "0 auto" }}>
          <div style={{
            display: "inline-block", background: "rgba(255,255,255,0.1)", 
            padding: "6px 14px", borderRadius: 100, fontSize: 13, 
            fontWeight: 600, marginBottom: 20, letterSpacing: 1
          }}>
            PROTEÇÃO DE DADOS (LGPD)
          </div>
          <h1 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "clamp(32px, 5vw, 48px)", fontWeight: 800, marginBottom: 24, lineHeight: 1.2 }}>
            Política de Privacidade
          </h1>
          <p style={{ fontSize: 18, opacity: 0.8, lineHeight: 1.6 }}>
            Seu cadastro é um voto de confiança. Nós levamos a proteção da sua privacidade a sério.
          </p>
        </div>
      </header>

      {/* Conteúdo */}
      <main style={{ maxWidth: 800, margin: "-40px auto 100px", padding: "0 24px", position: "relative", zIndex: 10 }}>
        
        <div className="fu2" style={{
          background: K.sur, borderRadius: K.r.xl, boxShadow: K.sh.l, padding: "40px clamp(20px, 5vw, 50px)"
        }}>
          
          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              Coleta de Informações
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15, marginBottom: 12 }}>
              Coletamos apenas as informações estritamente necessárias para a prestação do serviço de gestão e emissão de ingressos:
            </p>
            <ul style={{ color: K.mid, fontSize: 15, lineHeight: 1.8, paddingLeft: 20 }}>
              <li><strong>Dados de Identificação:</strong> Nome completo, CPF, E-mail e Telefone. Utilizados para emissão do ingresso nominal e contato.</li>
              <li><strong>Dados de Autenticação:</strong> Identificadores providos pelo Firebase Auth para gerir seu acesso à aba "Meus Ingressos".</li>
            </ul>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              Uso das Informações
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Nós <strong>não vendemos, alugamos ou comercializamos</strong> suas informações pessoais sob nenhuma hipótese. Seus dados são usados exclusivamente para:
            </p>
            <ul style={{ color: K.mid, fontSize: 15, lineHeight: 1.8, paddingLeft: 20, marginTop: 10 }}>
              <li>Geração do QR Code e validação antifraude na portaria.</li>
              <li>Comunicação de atualizações importantes sobre o evento.</li>
              <li>Compartilhamento (apenas o essencial para check-in) com os organizadores do evento que você adquiriu ingresso.</li>
            </ul>
          </section>

          <section style={{ marginBottom: 40 }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              Dados de Pagamento
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Todo o processamento de cartões de crédito e pagamentos PIX é feito integralmente no ambiente seguro do <strong>Mercado Pago</strong>. O Eventos e Encontros não tem acesso, não salva e não trafega pelos seus servidores nenhum número de cartão de crédito, código CVV ou senhas bancárias.
            </p>
          </section>

          <section>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, color: K.ink, marginBottom: 16 }}>
              Seus Direitos (LGPD)
            </h2>
            <p style={{ color: K.mid, lineHeight: 1.8, fontSize: 15 }}>
              Em conformidade com a Lei Geral de Proteção de Dados, você tem o direito de solicitar o acesso, retificação ou exclusão permanente dos seus dados do nosso sistema, bastando solicitar através da página de Fale Conosco. (Nota: ingressos ativos poderão ser afetados caso a exclusão seja solicitada antes do evento).
            </p>
          </section>

        </div>
      </main>

    </div>
  );
}
